// extracted by mini-css-extract-plugin
export default {"subHeader":"zfBg0w","titleContainer":"wq9SLE","breadcrumbs":"IvFN2B","category":"ozr0Ym","title":"GI4ApN","navigation":"gNhekq","buttonContainer":"mNkitY","button":"Wg_rk5"};